import { Injectable } from '@angular/core';
import { user } from '@constants/init-const';
import { Role } from '@interfaces/enums';
import { CustomerInfo } from '@interfaces/interfaces';
import { BehaviorSubject } from 'rxjs';
import { BffApiService } from '../bff-api.service';
import { NavigationService } from './navigation.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private userSource = new BehaviorSubject<CustomerInfo>(user);
  currentUser = this.userSource.asObservable();
  constructor(private bff: BffApiService, private nav: NavigationService) {
    this.getProfilInfos();
  }

  login(credential: any) {
    if (credential.invalid) {
      //   this.snack.error("Le formulaire est mal rempli");
      return;
    }
    this.bff.login(credential.value).subscribe((data: any) => {
      this.getProfilInfos();
      //   this.snack.info(successLogin)
      this.nav.goToDashboard();
    });
  }

  logout() {
    this.bff.logout().subscribe((data: any) => {
      //   this.snack.info(successLogout)
      this.nav.goToLogin();
      this.userSource.next({ firstname: '', lastname: '' });
    });
  }

  register(value: any) {
    this.bff.register(value).subscribe({
      next: (data) => {
        console.log(data);
        // this.snack.info('Vous êtes connecté')
        // this.nav.goToCheckEmail(value.email)
      },
      error: (err) => {
        console.error(err); // Log the error if needed
      },
    });
  }

  changePWD(values: any) {
    // TODO
    // this.bff.updatePassword(values).subscribe(data => {
    //   console.log(data)
    //   this.snack.snack('Mot de passe mis à jour')
    // })
  }

  updatePWD(values: any) {
    // this.bff.resetPassword(values).subscribe(data => {
    //   console.log(data)
    // })
  }

  /**
   * The Role returned can be read by using
   *
   * "then" :
   *
   * this.getProfilInfos().then((role) => {
   *   console.log('Role:', role);
   * });
   *
   * or "async/await":
   *
   * async someMethod() {
   *   const role = await this.getProfilInfos();
   *   console.log('Role:', role);
   * }
   */
  getProfilInfos(): Promise<Role> {
    return new Promise((resolve, reject) => {
      this.bff.getProfile().subscribe({
        next: (userValues) => {
          userValues.email = this.maskEmail(userValues.email);
          this.userSource.next(userValues);
          resolve(Role.RETAILER);
        },
        error: (err) => {
          console.error(err); // Log the error if needed
          resolve(Role.VISITOR);
        },
      });
    });
  }

  sendVerificationEmail() {
    this.bff.getToken().subscribe((data) => {
      //TODO is this correct ? @ARKAR
      this.bff.sendVerificationEmail().subscribe((data) => {
        console.log(data);
        // this.snack.info('Un mail de verification vous a été envoyé. Veuillez suivre les instructions du mail.')
      });
    });
  }

  getUser(): CustomerInfo {
    return this.userSource.value;
  }

  maskEmail(email: string): string {
    // Split the email into local part and domain
    const [localPart, domain] = email.split('@');

    if (localPart.length <= 1) {
      // If the local part is too short, just return the original email
      return email;
    }

    // Mask the local part (keeping the first character and replacing the rest with asterisks)
    const maskedLocalPart = localPart[0] + '*'.repeat(localPart.length - 1);

    // Return the masked email
    return `${maskedLocalPart}@${domain}`;
  }
}
